module.exports = __webpack_public_path__ + "static/media/pdfIcon.2198c8b3.svg";